import { NgClass } from '@angular/common'
import { Component, input, output } from '@angular/core'

@Component({
  selector: 'dhp-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrl: './toggle-button.component.scss',
  imports: [NgClass],
})
export class ToggleButtonComponent {
  readonly ariaLabel = input<string>('Toggle')
  readonly value = input<boolean>(false)

  readonly toggled = output<boolean>()
  readonly valueChange = output<boolean>()

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement | null
    if (!target) return
    const nextValue = target.checked
    this.toggled.emit(nextValue)
    this.valueChange.emit(nextValue)
  }
}
